import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import COLORS from '../../colors';
import { Button } from '../Button';
import styled from 'styled-components';

interface ActionModalProps {
  onClose: () => void;
  title: string;
  content: string;
  cancelButtonText?: string;
  okButtonText?: string;
  modalCallback: () => void;
}

const StyledDialogTitle = styled(DialogTitle)`
  background-color: ${COLORS.NEUTRAL_900};
  color: ${COLORS.WHITE};
  font-family: 'Helvetica Neue';
  font-size: 23.4px !important;
  font-style: normal;
  font-weight: 700 !important;
  line-height: 28px !important;
  letter-spacing: -0.468px !important;
`;

const StyledDialogActions = styled(DialogActions)`
  background-color: ${COLORS.NEUTRAL_900};
`;

const StyledDialogContentText = styled(DialogContentText)`
  font-size: 14px !important;
  font-style: normal;
  font-weight: 400 !important;
  line-height: 20px !important;
  letter-spacing: 0.25px !important;
  color: ${COLORS.NEUTRAL_500} !important;
`;

const ActionModal = ({
  onClose,
  title,
  content,
  cancelButtonText = 'Cancel',
  okButtonText = 'OK',
  modalCallback
}: ActionModalProps) => {
  return (
    <Dialog open onClose={onClose}>
      <StyledDialogTitle>{title}</StyledDialogTitle>
      <DialogContent sx={{ backgroundColor: COLORS.NEUTRAL_900 }}>
        <StyledDialogContentText>{content}</StyledDialogContentText>
      </DialogContent>
      <StyledDialogActions>
        <Button
          onClick={onClose}
          label={cancelButtonText}
          backgroundColor={COLORS.NEUTRAL_900}
          hoverBackgroundColor={COLORS.BUTTON_SECONDARY_HOVER}
          textColor={COLORS.PRIMARY_500}
          showShadow={false}
        />
        <Button
          onClick={modalCallback}
          label={okButtonText}
          backgroundColor={COLORS.PRIMARY_500}
          hoverBackgroundColor={COLORS.BUTTON_PRIMARY_HOVER}
          textColor={COLORS.PRIMARY_800}
        />
      </StyledDialogActions>
    </Dialog>
  );
};

export default ActionModal;
